import { isTermColor, isTermRanged } from 'Modules/termType';

export function uriEncodeTerm(term: string): string {
  return encodeURIComponent(isTermColorOrRanged(term) ? encodeSpacesDashes(term) : term);
}

export function uriDecodeTerm(term: string): string {
  const decoded = decodeURIComponent(term);
  return isTermColorOrRanged(decoded) ? decodeSpacesDashes(decoded) : decoded;
}

function isTermColorOrRanged(term: string): boolean {
  return isTermColor(term) || isTermRanged(term);
}

export function uriEncode(value: string): string {
  return encodeURIComponent(encodeSpacesDashes(value));
}

export function uriDecode(value: string): string {
  return decodeSpacesDashes(decodeURIComponent(value));
}

function encodeSpacesDashes(value: string): string {
  return value.replace(/([^\s-])(-+)/g, '$1$2-').replace(/([^\s-]) ([^\s-])/g, '$1-$2');
}

function decodeSpacesDashes(value: string): string {
  return value.replace(/([^\s-])-([^\s-])/g, '$1 $2').replace(/([^\s-])-/g, '$1');
}
